if (!customElements.get('brands-component')) {
    class Brands extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.selectors = {
                sliderWrapper: '.brands-wrapper',
                pagination: '.swiper-pagination',
            };
            this.classes = {
                grid: 'grid',
                swiper: 'swiper',
                swiperWrapper: 'swiper-wrapper',
            };

            this.sectionId = this.dataset.sectionId;
            this.section = this.closest(`.section-${this.sectionId}`);
            this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

            this.enableSlider = this.dataset.enableSlider === 'true';
            this.items = parseInt(this.dataset.items);

            this.sliderInstance = false;

            if (!this.enableSlider) return;

            this.init();
            window.addEventListener('resize', () => {
                this.init();
            });
        }

        init() {
            if (window.innerWidth < 1024) {
                this.destroySlider();
            } else {
                this.initSlider();
            }
        }

        initSlider() {
            const sliderOptions = {
                slidesPerView: this.items > 6 ? 6.8 : this.items,
                spaceBetween: 0,
                slidesOffsetBefore: 70,
                slidesOffsetAfter: 70,
                loop: false,
                threshold: 2,
            };

            if (typeof this.sliderInstance !== 'object') {
                this.classList.add(this.classes.swiper);
                this.sliderWrapper.classList.remove(this.classes.grid);
                this.sliderWrapper.classList.add(this.classes.swiperWrapper);
                this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
                this.sliderInstance.init();

                const focusableElements = FoxTheme.a11y.getFocusableElements(this);

                focusableElements.forEach((element) => {
                    element.addEventListener('focusin', () => {
                        const slide = element.closest('.swiper-slide');
                        this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
                    });
                });
            }
        }
        destroySlider() {
            this.classList.remove(this.classes.swiper);
            this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
            this.sliderWrapper.classList.add(this.classes.grid);
            if (typeof this.sliderInstance === 'object') {
                this.sliderInstance.slider.destroy();
                this.sliderInstance = false;
            }
        }
    }
    customElements.define('brands-component', Brands);
}
